<iframe #iframe frameborder="0" scrolling="yes" (load)="resizeIframe(iframe)" [ngStyle]="style"></iframe>